module.exports = __webpack_public_path__ + "static/img/member_vip_bg_y.26afe69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/member_vip_bg_y.png
// module id = G9Ou
// module chunks = 1